module.exports = __webpack_public_path__ + "static/media/btn-cerrar.f1e58acd.svg";